<template lang="html">

  <div class="trabaja-nosotros">


   <section class="intro-xs">
    <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
      <div class="container-text">
        <h2 class="title title-52" v-html="$t('trabaja_con_nosotros.intro.titulo')"></h2>
      </div>
    </div>
  </section>


  <section class="desc-work">
    <div class="flex wrap">
      <div class="col-50 flex column align-end pad-sec">
        <p>{{$t('trabaja_con_nosotros.intro.texto')}}</p>
      </div>
      <div class="col-50">

      </div>
    </div>
  </section>

  <section class="cv-form pad-sec">
    <div class="container">
      <formulario></formulario>
    </div>
  </section>

  <otras-secciones :data="['productos','tecnologia']"></otras-secciones>
  

</div>

</template>

<script lang="js">

  import formulario from '@/components/view-parts/trabaja-con-nosotros/formulario'

  import Otras_Secciones from '@/components/parts/acceso-a-secciones';

  export default  {
    name: 'trabaja-con-nosotros',
    props: [],
    mounted() {

    },
    data() {
      return {
        
      }
    },
    methods: {

    },
    components: {
      'formulario' : formulario,
      'otras-secciones' : Otras_Secciones,
    }
  }
</script>

<style scoped>
.intro-xs .container-text{
  max-width: 570px;
  padding: 0;
  margin-right: 0;
}

.intro-xs h2{
  position: relative;
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/trabaja-con-nosotros.vue